import Axios, { isAxiosError } from "axios";

export const SESSION_EXPIRED_EVENT = "mytender:session-expired";

const axios = Axios.create();

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isAxiosError(error) && error.response?.status === 401) {
      window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
    }
    return Promise.reject(error);
  }
);

export default axios;
